import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import './education.component.css'
const Education = () => {
  const EducationData = [
    {
      name: "Harmonics",
      logo: Img.eduLogo1,
      pic: Img.edu1,
    },
    {
      name: "Swipetrades",
      logo: Img.eduLogo2,
      pic: Img.edu2,
    },
    {
      name: "",
      logo: Img.eduLogo3,
      pic: Img.edu3,
    },
  ];

  const EducationSide = EducationData.slice(0, 2);
  return (
    <VStack bgColor="rgba(245, 245, 255, 1)" py="100px" className="edu-area">
      {/* Desktop Version */}
      <Box w="80%" m="auto" className="desktop-education">
      <Stack
        flexDir="row"
        justifyContent="space-between"
        alignItems={"center"}
        w="100%"
        py="25px"
      >
        <Box>
          <Text
            color="rgba(0, 0, 0, 1)"
            fontSize="36px"
            fontWeight={"700"}
            fontFamily={"font-family: 'Poppins', sans-serif;"}
          >
            Strategies Educations
          </Text>
        </Box>
        <Box>
          <Text
            color="rgba(0, 0, 0, 1)"
            fontSize="20px"
            fontWeight={"400"}
            cursor={"pointer"}
            fontFamily={"ProximaNova"}
          >
            See all
          </Text>
        </Box>
      </Stack>
        {/* Stack */}
        <VStack my="25px">
            {
                EducationData.map((item)=>{
                    return(
                        <Stack w="100%">
                        <Stack position={"relative"} w={"100%"} my="20px">
                          <Image src={item.pic} w="100%" h={"auto"} borderRadius={"25px"} />
                          <Box
                            h={"100%"}
                            w="100%"
                            position={"absolute"}
                            top={"0"}
                            left={"0"}
                            bottom={"0"}
                            right={"0"}
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                            overflow={"hidden"}
                          >
                            <Box padding="41px">
                              <Text
                                color="rgba(255, 255, 255, 1)"
                                fontSize="64px"
                                fontWeight={"800"}
                                fontFamily={"'Poppins', sans-serif;"}
                              >
                                {item.name}
                              </Text>
                            </Box>
                            <Box padding="41px">
                              <Image
                                src={item.logo}
                                maxWw="100%"
                                borderRadius={"25px"}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Stack>
                    )
                })
            }
        </VStack>
      </Box>

      {/* mobile Version */} 
      <Box w="80%" m="auto" className="mobile-education">
      <Stack
        flexDir="row"
        justifyContent="space-between"
        alignItems={"center"}
        w="100%"
        py="25px"
      >
      </Stack>
        {/* Stack */}
        <VStack my="25px" w="100%">
            {
                EducationSide.map((item)=>{
                    return(
                        <Stack w="100%" h={"100%"}>
                        <Stack position={"relative"} w={"100%"} my="20px" h={"100%"}>
                          <Image src={item.pic} w="100%"  h="355px" objectFit={'cover'} borderRadius={"25px"} objectPosition={'39%'}/>
                          <Box
                            h={"100%"}
                            w="100%"
                            position={"absolute"}
                            top={"0"}
                            left={"0"}
                            bottom={"0"}
                            right={"0"}
                            display={"flex"}
                            flexDir='column'
                            alignItems={"flex-start"}
                            justifyContent={"space-between"}
                            overflow={"hidden"}
                          >
                          <Box padding="15px">
                              <Image
                                src={item.logo}
                                w="87px"
                                h="87px"
                                borderRadius={"25px"}
                              />
                            </Box>
                            <Box pb="30px" w="100%">
                              <Text
                              textAlign='center'
                                color="rgba(255, 255, 255, 1)"
                                fontSize="36px"
                                fontWeight={"700"}
                                fontFamily={"ProximaNova"}
                                w="100%"
                              >
                                {item.name}
                              </Text>
                            </Box>

                          </Box>
                        </Stack>
                      </Stack>
                    )
                })
            }
        </VStack>
      </Box>
    </VStack>
  );
};

export default Education;
